import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useSocket } from '@/contexts/SocketContext';
import { agentAPI } from '../api/agent.api';

export const useAgentPendingCount = () => {
  const queryClient = useQueryClient();
  const { socket } = useSocket();

  const { data, refetch } = useQuery({
    queryKey: ['agent-pending-count'],
    queryFn: () => agentAPI.getPendingCount(),
    staleTime: 15000,
    gcTime: 60000,
  });

  useEffect(() => {
    if (!socket) return;

    const handleUpdate = () => {
      queryClient.invalidateQueries({ queryKey: ['agent-pending-count'] });
    };

    socket.on('agent:stats:updated', handleUpdate);
    socket.on('agent:plan:created', handleUpdate);
    socket.on('agent:plan:updated', handleUpdate);

    return () => {
      socket.off('agent:stats:updated', handleUpdate);
      socket.off('agent:plan:created', handleUpdate);
      socket.off('agent:plan:updated', handleUpdate);
    };
  }, [socket, queryClient]);

  return {
    pendingCount: data?.data?.pending_count || 0,
    refetch,
  };
};
